// DeleteConfirmModal.tsx
import { Modal } from 'antd';

type DeleteConfirmModalProps = {
  open: boolean;
  isParent: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
};

const DeleteConfirmModal = ({
  open,
  isParent,
  onCancel,
  onConfirm,
}: DeleteConfirmModalProps) => {
  return (
    <Modal
      open={open}
      title="Are you sure?"
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Delete"
      cancelText="Cancel"
    >
      {isParent
        ? 'This will also delete all child areas related to this room.'
        : 'Do you want to delete this area?'}
    </Modal>
  );
};

export default DeleteConfirmModal;
